const ConvertObjToArray = (d) => {
    console.log("Convertir datos");
    console.log(d);
      if(d!=undefined){
      const objectArray = Object.values(d);
      return objectArray;
      }else return null
        };
  
      const ConvertDate= (d) => {
         // const newDate = new Date(d.seconds*1000);
         const newDate = new Date(d.seconds*1000);    
         console.log(d);
          console.log(d.seconds*1000);
          return newDate.toLocaleString();
        }
  
  function SelectOption(e,updateState){
          let d={value:e.target.value,text:e.target.options[e.target.selectedIndex].text}
          updateState(d);  
  }
  const ConvertObjToArrayList = (d) => {
    if (d !== undefined) {
      const objectArray = Object.values(d).map((item) => ({
        value: item.Id.toString(),
        label: item.Nom,
      }));
      return objectArray;
    } else {
      return null;
    }
  };
  function ConvertToImg(src){
  const pageImage = new Image();
  pageImage.src = src;
  pageImage.onload = function() {
      const canvas = document.createElement('canvas');
      canvas.width = pageImage.naturalWidth;
      canvas.height= pageImage.naturalHeight;
      const ctx = canvas.getContext('2d');
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(pageImage, 0, 0);    
     // saveScreenshot(canvas);
  }
  return pageImage;
  }
  function saveScreenshot(canvas) {
      let fileName = "image"
      const link = document.createElement('a');
      link.download = fileName + '.png';   
      canvas.toBlob(function(blob) {
          console.log(blob)
          link.href = URL.createObjectURL(blob);
          link.click();
      });
  };
  function resizeImagemin(imageUrl,callback) {
    const image = new Image();
    image.onload = function() {
      // Determine the appropriate width and height based on the original size
      const width = this.naturalWidth > 2000 ? this.naturalWidth * 0.2 : this.naturalWidth * 0.30;
      const height = this.naturalWidth > 2000 ? this.naturalHeight * 0.2 : this.naturalHeight * 0.30;
      
      // Create a canvas and resize the image using drawImage
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(this, 0, 0, width, height);
      
      // Convert the resized image to a data URL and pass it to the callback function
      const dataURI = canvas.toDataURL('image/jpeg');
      callback(dataURI);
    };
    
    image.onerror = function() {
      // Handle any errors that occur while loading the image
      console.error('Error loading image:', imageUrl);
      callback(null);
    };
    
    image.src = imageUrl;
  }
        export { ConvertObjToArray,SelectOption,ConvertToImg,ConvertDate,ConvertObjToArrayList};